module.exports = __webpack_public_path__ + "static/media/ycard_maestro.ae47b3a9.svg";